<template>
  <p-form-element
    show-messages
    :errors="innerErrors"
    :messages="innerMessages"
    :class="classList"
  >
    <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
    <label v-if="!solo" :for="'textarea-' + _uid" class="text-field-label">
      {{ innerLabel }}
    </label>
    <div class="p-textarea-wrapper">
      <textarea
        :id="'textarea-' + _uid"
        ref="input"
        :required="innerRequired ? true : undefined"
        :disabled="disabled"
        :type="innerType"
        :readonly="readonly || disabled"
        :value="value"
        :min="min"
        :max="max"
        :step="step"
        :placeholder="placeholderComputed"
        :autofocus="autofocus"
        :inputmode="inputmode"
        :pattern="pattern"
        :cols="cols"
        :rows="rows"
        :minlength="minLength"
        :maxlength="maxLength"
        :title="solo ? placeholder : undefined"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
      ></textarea>
    </div>
  </p-form-element>
</template>

<script lang="ts">
  import interactable from '../../mixins/interactable/interactable';
  import colorable from '../../mixins/colorable/colorable';
  import clearable from '../../mixins/clearable/clearable';
  import loadable from '../../mixins/loadable/loadable';
  import validatable from '../../mixins/validatable/validatable';
  import mixins from '../../mixins';
  import PTextField from '../p-text-field/p-text-field.vue';

  export default mixins(validatable, loadable, clearable, colorable, interactable).extend({
    props: {
      ...((new PTextField()).$options.props),
      wrap: { type: Boolean, default: false },
      minLength: { type: [Number, String], default: undefined },
      maxLength: { type: [Number, String], default: undefined },
      cols: { type: [Number, String], default: undefined },
      rows: { type: [Number, String], default: undefined },
    },
    computed: {
      placeholderComputed() {
        return (this as any).solo ? this.innerLabel : (this as any).placeholder;
      },
      classList(): Record<string, any> {
        return {
          'p-textarea': true,
          solo: (this as any).solo,
          required: this.innerRequired,
          focused: this.isFocused,
          disabled: this.disabled,
          loading: this.loading,
          invalid: ((this.innerErrors ?? []) as any[]).length > 0,
          'is-clearable': this.clearable,
        };
      },
    },
    data: () => ({
      isFocused: false,
    }),
    methods: {
      onInput(event: InputEvent) {
        const target = event!.target! as HTMLInputElement;
        const value = target.value === '' ? undefined : target.value;
        this.$emit('input', value);
      },
      onFocus(value: FocusEvent) {
        (this as any).isFocused = true && !this.disabled;
        this.$emit('focus', value);
      },
      onBlur(value: FocusEvent) {
        (this as any).isFocused = false && !this.disabled;
        this.$emit('blur', value);
      },
    },
  });
</script>
